class ContentDropdown {
    constructor() {
        this.dropdowns = document.querySelectorAll('.js-content-dropdown');
        this.triggers = document.querySelectorAll('.js-content-dropdown-trigger');

        if (this.triggers) {
            this.triggers.forEach((elem, index) => { this.initEvent(elem, index); });
        }
    }

    initEvent(element, index) {
        element.addEventListener('click', () => { this.switchContent(index); });
    }

    switchContent(index) {
        if (!this.dropdowns[index].classList.contains('competitions__announcement--display')) {
            this.dropdowns[index].classList.add('competitions__announcement--display');
        } else {
            this.dropdowns[index].classList.remove('competitions__announcement--display');
        }
    }
}

const contentDropdown = {
    init() {
        return new ContentDropdown();
    },
};

export default contentDropdown;
